<template>
  <div>
    <vs-card>
      <b-row>
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-button
            style="border-color: white"
            v-on:click="runReport('head')"
            class="bg-primary vs-con-loading__container"
            id="loading-stock-move"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("HeadList") }}
          </b-button>
        </b-col>
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-button
            style="border-color: white"
            v-on:click="runReport('item')"
            class="bg-primary vs-con-loading__container"
            id="loading-stock-move"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("ItemList") }}
          </b-button>
        </b-col>
      </b-row>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table-matched-stock-list-rep ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
        @filter-changed="onFilterChanged"
        :gridOptions="gridOptions"
        :rowClassRules="rowClassRules"
        :chartToolPanelsDef="chartToolPanelsDef"
      >
      </ag-grid-vue>
      <div id="chartContainer" class="ag-theme-quartz"></div>
    </vs-card>
    <vs-popup
      class="holamundo"
      :title="$t('StocktransDetail') + ' (' + infoData.Stockno + ') '"
      :active.sync="isSstocktransDetailPopup"
      fullscreen
    >
      <StockTransDetails :data="infoData" :type="'stock2'" />
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import { Icon } from "@iconify/vue2";
import StockTransDetails from "./StockTransDetails.vue";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import moment from "moment";
export default {
  components: { AgGridVue, Icon, StockTransDetails, detailBtnCellRenderer },
  data() {
    return {
      gridApi: null,
      isSstocktransDetailPopup: false,
      infoData: [],
      chartToolPanelsDef: {
        defaultToolPanel: "settings",
      },
      rowClassRules: null,
      gridOptions: {
        enableCharts: true,
        chartThemes: ["ag-default"],
      },
      ROLE: this.$store.state.AppActiveUser.ROLE,
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  methods: {
    recreateChart(params, value) {
      try { 
        const chartContainer = document.querySelector("#chartContainer");
        chartContainer.innerHTML = ""; 
        params.createRangeChart({
          cellRange: {
            columns:
              value == "item"
                ? ["MatchingBarcode", "QEntery", "QExit"]
                : ["masterBarcode", "qEntery", "qExit"],
            rowStartIndex: 0,
            rowEndIndex: 10,
          },
          chartType: "groupedColumn",
          chartContainer: document.querySelector("#chartContainer"),
          suppressChartRanges: true,
          chartToolPanelsDef: {
            defaultToolPanel: "settings",
          },
        }); 
 
      } catch (error) {
        console.log(error);
      }
    },
    onFilterChanged(params) { 
      this.recreateChart(params.api, "title");
    },
    onCellKeyDown(event) {
      if (event.event.key === "Enter") {
        const nextRowIndex = event.rowIndex + 1;
        const colKey = event.column.getId();

        if (nextRowIndex < event.api.getDisplayedRowCount()) {
          this.onCellValueChanged(event);
        } else {
          event.api.stopEditing();
        }
      }
    },
    onFirstDataRendered(params) { 
			console.log("onFirstDataRendered")
      params.api.createRangeChart({
        cellRange: {
          columns: ["masterBarcode", "qEntery", "qExit"],
          rowStartIndex: 0,
          rowEndIndex: 10,
        },
        chartType: "groupedColumn",
        chartContainer: document.querySelector("#chartContainer"),
        suppressChartRanges: true,
        chartToolPanelsDef: {
          defaultToolPanel: "settings",
        },
      });
      params.api.sizeColumnsToFit();
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    runReport(title) {
      const vs = this.$vs;
      let type = "material";
      setTimeout(() => {
        vs.loading({
          container: `#loading-stock-move`,
          type,
          scale: 0.5,
        });
      }, 500);

      let compId = "";
      if (this.ROLE == "Company") compId = this.activeUserInfo.companyid;
      else compId = null;

      let obj = {};
      if (title == "head") {
        obj = {
          companyId: compId,
          name: this.ROLE == "Company" ? "MatchStockCompany" : "MatchStock",
        };
      } else if (title == "item") {
        obj = {
          companyId: compId,
          name:
            this.ROLE == "Company" ? "MatchedStockItemForCompany" : "MatchedStockItem",
        };
      }
      try {
        this.$store
          .dispatch("report/runReports", obj)
          .then((response) => {
            if (response.success == true) {
              setTimeout(() => {
                vs.loading.close("#loading-stock-move > .con-vs-loading");
              }, 1000);
              this.columns = [];
              this.processList = JSON.parse(response.json); 
              if (this.processList.length > 0) {
                let columnList = Object.keys(this.processList[0]);
                this.columns.push({
                  width: 120,
                  pinned: "left",
                  cellRendererFramework: "detailBtnCellRenderer",
                  cellRendererParams: {
                    detailMethods: "stockTransDetail",
                    iconDetail: "icon-park-outline:doc-detail",
                    iconColor: "#065a82",
                  },
                });
                columnList.forEach((val, index) => {
                  if (val == "CompanyName") {
                    this.columns.push({
                      pinned: "left",
                      headerName: this.$t(val),
                      field: val,
                      filter: "agSetColumnFilter",
                    });
                  } else if (val == "CompanyTransType") {
                    this.columns.push({
                      headerName: this.$t(val),
                      field: val,
                      filter: "agSetColumnFilter",
                      cellRendererFramework: "CustomerActListTransferType",
                    });
                  } else if (val.toString().includes("Date") == true) {
                    this.columns.push({
                      headerName: this.$t(val),
                      field: val,
                      filter: "agSetColumnFilter",
                      valueFormatter: (params) => this.parseDate(params.data[val]),
                      editable: true,
                    });
                  } else if (
                    val.toString().includes("Id") == false &&
                    val.toString().includes("InfoType") == false
                  )
                    this.columns.push({
                      headerName: this.$t(val),
                      field: val,
                      filter: "agSetColumnFilter",
                    });
                });
                this.recreateChart(this.gridApi, title);
              }
            } else {
              setTimeout(() => {
                vs.loading.close("#loading-stock-move > .con-vs-loading");
              }, 1000);
              console.log(response);
            }
          })
          .catch((error) => {
            setTimeout(() => {
              vs.loading.close("#loading-stock-move > .con-vs-loading");
            }, 1000);
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      } catch (error) {
        setTimeout(() => {
          vs.loading.close("#loading-stock-move > .con-vs-loading");
        }, 1000);
        console.log(error);
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  created() {
    this.runReport("head");
    this.rowClassRules = {
      // row style function
      "bg-danger-item-ag": (params) => {
        var difference =
          parseFloat(params.data.qEntery == null ? 0 : params.data.qEntery) -
          parseFloat(params.data.qExit == null ? 0 : params.data.qExit);
        var quantityMin = parseFloat(
          params.data.QuantityMin == null || params.data.QuantityMin == ""
            ? 0
            : params.data.QuantityMin
        );
        return difference <= quantityMin && difference != 0;
      },
      "bg-success-item-ag": (params) => {
        var difference = params.data.isCreate;
        return difference == "success";
      },
    };
  },
  mounted() {
    this.$root.$on("stockTransDetail", (data) => {
      this.infoData = data;
      this.isSstocktransDetailPopup = true;
    });
  },
  beforeDestroy() {
    this.$root.$off("stockTransDetail");
  },
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table-matched-stock-list-rep {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 110px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
[dir] .btn-group button {
  padding: 4px !important;
}
.bg-success-item-ag {
  background-color: #f4f9c4 !important;
}

.bg-danger-item-ag {
  background-color: #f8cbcc !important;
}
</style>
